import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { HistoryComparison } from "src/app/models/HistoryComparison";
import { ServerResponse } from "src/app/models/ServerResponse";
import { ContractsService } from "src/app/services/contracts.service";

@Component({
    selector: 'history-dialog',
    templateUrl: './history-dialog.component.html',
    styleUrls: ['./history-dialog.component.scss']
})

export class HistoryDialogComponent implements OnInit {
    historyComparison!: HistoryComparison;
    constructor(private _dialogRef: MatDialogRef<HistoryDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: { contractId: string, historyId: string }, private _contractsService: ContractsService) { }

    ngOnInit(): void {
        this._contractsService.getContractHistoryComparison(this.data.contractId, this.data.historyId).subscribe((res: ServerResponse<HistoryComparison>)=>{
            this.historyComparison = res.data;
        });
    }
}